/* eslint-disable max-len */
import {
  Utils,
  QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS,
  QUERY_PARAM_PLA_CONFIGURATION_GUID
} from '../app/utils/urlUtils';
import { getPlaConfiguredPrice } from '../app/utils/plaConfigurationUtils';

export const setGooglePlaData = (plaConfigurationDetails, plaConfiguredPrice) => {
  const plaGoogleDataId = 'script__pla-google-data';
  let scriptPlaGoogleData = document.querySelector(`#${plaGoogleDataId}`);
  if (!scriptPlaGoogleData) {
    const baseURI = Utils.getBaseURI();
    const baseConfig = Utils.getParameterByName(QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS);
    const plaGuid = Utils.getParameterByName(QUERY_PARAM_PLA_CONFIGURATION_GUID);
    const { title, media, configuration } = plaConfigurationDetails;
    const { product, brand } = configuration;
    const price = getPlaConfiguredPrice(plaConfiguredPrice);
    const galleryUrls = media.images.map((img) => img.url.replace('<SIZE>', '100'));

    const url = `${baseURI}?${QUERY_PARAM_PLA_CONFIGURATION_GUID}=${plaGuid}&${QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS}=${baseConfig}`;

    const script = document.createElement('script');
    script.id = plaGoogleDataId;
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: title,
      alternateName: product?.name,
      url,
      productID: plaGuid,
      sku: product?.omsId,
      description: product?.name,
      image: galleryUrls,
      brand: {
        '@type': 'Brand',
        name: brand?.name,
      },
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        price,
        priceCurrency: 'USD'
      },
    });

    document.head.appendChild(script);
  }
};
